import React from 'react';
import { PowerOff } from 'lucide-react';

export default function DiscontinuedPage() {
  return (
    <div data-testid="discontinued-page" className="min-h-screen bg-slate-950 flex items-center justify-center px-6">
      <div className="max-w-xl w-full text-center space-y-8">
        <div className="mx-auto w-20 h-20 rounded-full bg-red-500/10 border border-red-500/30 flex items-center justify-center">
          <PowerOff className="w-10 h-10 text-red-400" />
        </div>
        <div className="space-y-4">
          <h1 data-testid="discontinued-title" className="text-3xl sm:text-4xl font-bold text-white tracking-tight">
            Sistema cancelado
          </h1>
          <p data-testid="discontinued-message" className="text-slate-300 text-base leading-relaxed">
            O Tomaselli optou pelo <strong className="text-white">Slap Festas</strong>.
          </p>
          <p className="text-slate-400 text-sm leading-relaxed">
            A energia mental deve ser direcionada para a implementação do novo sistema de responsabilidade do Tomaselli.
          </p>
        </div>
      </div>
    </div>
  );
}
